import { useContext } from 'react';
import { CurrentPractitionerRoleContext } from '../../PractitionerRole/containers/CurrentPractitionerRoleProvider';
import { can } from '../permissions';

const RequirePermission = ({ action, resource, children }) => {
  const [currentPractitionerRole] = useContext(CurrentPractitionerRoleContext);
  return can(currentPractitionerRole, action, resource) ? children : null;
};
export default RequirePermission;
